import request from '@/utils/request'

let ActivityApi = {

  /*活动列表*/
  activityList (data, errorback) {
    return request._postBody('/supplier/activity/index', data, errorback)
  },

  addActivity (data, errorback) {
    return request._postBody('/supplier/activity/add', data, errorback)
  },

  editActivity (data, errorback) {
    return request._postBody('/supplier/activity/edit', data, errorback)
  },

  deleteActivity (data, errorback) {
    return request._post('/supplier/activity/delete', data, errorback)
  },

  getActivityDetailById (data, errorback) {
    return request._get('/supplier/activity/detail', data, errorback)
  },

  setPacketStatus (data, errorback) {
    return request._post('/supplier/activity/setPacketStatus', data, errorback)
  },

  setActivityStatus (data, errorback) {
    return request._post('/supplier/activity/setActivityStatus', data, errorback)
  },

  getJoinUserList (data, errorback) {
    return request._postBody('/supplier/activity/joinUserList', data, errorback)
  },

  addJoinUserList (data, errorback) {
    return request._postBody('/supplier/activity/joinUser/add', data, errorback)
  },

  delJoinUser (data, errorback) {
    return request._post('/supplier/activity/joinUser/delete', data, errorback)
  },

  getPacketRecordList (data, errorback) {
    return request._postBody('/supplier/activity/packet/record/list', data, errorback)
  },

}

export default ActivityApi



// WEBPACK FOOTER //
// ./src/api/activity.js